// AI Upgraded Component
import { Component, Input, OnInit } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { CsvExportDialogComponent } from '../dialog/dialog.component';
import { MON_EVENTS } from '@monsido/ng2/core/constants/mon-events.constant';
import { ExportNamePipe } from '../../filters/export-name.pipe';

@Component({
    selector: 'csv-export-button',
    templateUrl: './button.component.html',
    standalone: false,
})
export class CsvExportButtonComponent implements OnInit {
    @Input() category?: string;
    @Input() categoryName?: string;
    @Input() exports: any[] = [];
    @Input() clsSize?: string;
    @Input() clsMargin?: string;
    @Input() clsPR: boolean = false;
    @Input() monDisabled: boolean = false;

    enableExport: boolean = false;

    constructor (
        private readonly monEventService: MonEventService,
        private readonly translateService: TranslateService,
        private readonly activeFeatureService: ActiveFeatureService,
        private readonly exportNamePipe: ExportNamePipe,
    ) {}

    ngOnInit (): void {
        this.enableExport = this.activeFeatureService.isFeatureActivePure('data_export');
        if (this.category) {
            const categories = this.category.split(',');
            categories.forEach((category) => {
                this.exports.push({
                    name: this.categoryName ?? `${this.translateService.getString('Start export')} ${this.exportNamePipe.transform(category)}`,
                    data: { category },
                });
            });
        }
    }

    getCls (): string {
        let cls = '';
        cls += this.clsSize ? ` ${this.clsSize}` : ' py-2 px-3';
        cls += this.clsMargin ? ` ${this.clsMargin}` : ' mr-2';
        if (this.clsPR) {
            cls += ' pull-right';
        }
        return cls;
    }

    exportFiles (): void {
        const dialogParams = {
            component: CsvExportDialogComponent,
            dialogOptions: {
                size: 'sm',
                classes: 'fade-animation middle center mon-dialog',
            },
            data: {
                exports: this.exports,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_NG2_DIALOG, dialogParams);
    }
}
